<div class="grid gap-2 mt-2 mb-1 pr-4 pl-8 items-center" [style.grid-template-columns]="gridTemplateColumns()">
    <ng-content selector="app-table-header"></ng-content>
</div>
